import fr from './translation'

//Write here all the changes to translations that are not correct
fr.messages.setting.welcome1 = "Bonjour {name}"
fr.messages.home.welcome1 = "Bonjour {name}"
fr.messages.location.welcome1 = "Bonjour {name}"
fr.messages.team.invite.joinTeam2 = "Tu as été invité à l'emplacement {location} dans l'application Octopus Order !\n Avec le code {link}, tu peux rejoindre ta nouvelle équipe.\n Pour Android : {appLinkAndroid}\n Pour IOS : {appLinkIOS}"
fr.messages.register.thank = "Merci {name}"
fr.object.notificationOption = "@:object.notification{'soptions'}"
fr.label.day = 'Jour'
export default fr
